/**
 * @constructor
 * @param {Foundation.Form} form
 * @implements {Foundation.Form.Validator}
 */
Foundation.Form.Validator.Required = function () {};

Foundation.Form.Validator.Required.prototype.identifier = function () {
    return "required";
};

/**
 * @param {jQuery} fieldElements
 * @return {Foundation.Promise}
 */
Foundation.Form.Validator.Required.prototype.validate = function (fieldElements) {
    var result = new Foundation.Promise();
    var errorObj = {};
    var foundMissingRequiredFields = false;

    fieldElements.each(function (i, element) {
        element = jQuery(element);
        if (element.val() === "" || element.val().match(/^\s+$/)) {
            if (!foundMissingRequiredFields) {
                errorObj["message"] = "Missing required fields.";
                errorObj["fields"] = [];
                foundMissingRequiredFields = true;
            }
            errorObj["fields"].push(element.attr("name"));
        }
    });

    if (foundMissingRequiredFields) {
        result.set("errors", [errorObj]);
        result.fail();
    }
    else {
        result.fulfill();
    }

    return result;
};

Foundation.Form.registerValidator(Foundation.Form.Validator.Required);
